// The Bison Commerce design system, verbatim (assets/brand/design-system.html
// `:root` and its component CSS in the hub; published at
// reports.bisoncommerce.com/design-system). The Opportunity page's live-data
// widgets draw from this file and nothing else (Bill, 2026-09-08: enforce the
// design system strictly across the page: tables, cards, charts, colours).
// `theme/tokens.ts` mirrors the public website and still styles the room's
// chrome; where the two disagree on a data widget, this file wins.

export const ds = {
    navy: "#001F38",
    white: "#FFFFFF",
    gray50: "#F7F7F7",
    gray100: "#F0F0F6",
    gray200: "#DADDE5",
    gray300: "#B5B5BA",
    gray400: "#9D9CA3",
    // --bc-gray-500 is used by .kpi-label and .ds-section-desc but not declared
    // in the design system's :root; the website's muted text token stands in.
    gray500: "#6B7387",
    gray600: "#4B5367",
    gray700: "#3B3947",
    info: { text: "#2E75B6", bg: "#EFF6FF", border: "#BFDBFE" },
    warning: { text: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
    danger: { text: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
    text: { xs: 11, sm: 13, base: 15, lg: 18, xl: 22, "2xl": 28, "3xl": 36 },
    radius: 8,
    radiusLg: 12,
    shadowSm: "0 1px 2px rgba(0,31,56,0.05)",
} as const;

// .kpi-card / .card: white, 1px gray-200, radius-lg, shadow-sm.
export const dsCardSx = {
    bgcolor: ds.white,
    border: `1px solid ${ds.gray200}`,
    borderRadius: `${ds.radiusLg}px`,
    boxShadow: ds.shadowSm,
    p: "20px",
    minWidth: 0,
} as const;
